var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizWrongIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.365 1 1 4.365 1 8.5S4.365 16 8.5 16 16 12.635 16 8.5 12.635 1 8.5 1zm0 14.423A6.931 6.931 0 0 1 1.577 8.5 6.931 6.931 0 0 1 8.5 1.577 6.931 6.931 0 0 1 15.423 8.5 6.931 6.931 0 0 1 8.5 15.423z",
    fill: "#837E81",
    stroke: "#837E81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 6.577 11.193 6 8.885 8.308 6.577 6 6 6.577l2.308 2.308L6 11.193l.577.577 2.308-2.308 2.308 2.308.577-.577-2.308-2.308 2.308-2.308z",
    fill: "#837E81",
    stroke: "#837E81",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizWrongIcon);
export default __webpack_public_path__ + "static/media/quiz-wrong-icon.f325dfd5.svg";
export { ForwardRef as ReactComponent };